<template>
    <div class="space-y-4">
        <button
            v-if="countSelected > 0"
            class="fixed top-14 right-[max(0.75rem,calc(50vw-20rem))] z-20 w-12 h-12 rounded-full bg-primary text-primary-fg shadow-lg flex items-center justify-center text-xl font-bold"
            @click="done"
        >
            ✓
        </button>

        <h2 class="font-semibold">{{ t('ticketsets.chooseTicketsets') }}</h2>

        <div>
            <div class="bg-surface-card p-3 rounded">
                <AppCheckbox
                    v-model="selectAllActive"
                    :label="t('ticketsets.selectAll')"
                    @update:modelValue="selectAll"
                />
                <div class="text-sm opacity-70 mt-1">{{ t('ticketsets.ticketCount') }} {{ countSelectedTickets }}</div>
            </div>

            <div v-for="ev in activeEvents" :key="ev.id" class="mt-3">
                <h3 class="font-semibold">{{ ev.name }} ({{ formatDate(ev.startAt, 'D.M.YYYY') }})</h3>
                <div class="space-y-1 mt-1">
                    <div v-for="ts in ev.ticketsets" :key="ts.id" class="bg-surface-card p-3 rounded flex flex-col">
                        <AppCheckbox v-model="ts.selected" :label="ts.name" />
                        <div class="text-sm opacity-70 ml-7">{{ t('ticketsets.ticketCount') }} {{ ts.count }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { computed, ref } from 'vue'
    import { useRouter } from 'vue-router'
    import { useEventsStore } from '@/stores/events'
    import { useI18n } from 'vue-i18n'
    import { initSound } from '@/services/sound'
    import AppCheckbox from '@/components/ui/AppCheckbox.vue'
    import { formatDate } from '@/services/util/date'

    const events = useEventsStore()
    const router = useRouter()
    const { t } = useI18n()

    const selectAllActive = ref(false)

    const activeEvents = computed(() =>
        events.activeEvents
            .map(id => events.events.find(e => e.id === id))
            .filter((e): e is NonNullable<typeof e> => Boolean(e))
    )

    const allTicketsets = computed(() => activeEvents.value.flatMap(e => e.ticketsets))

    const countSelected = computed(() => allTicketsets.value.filter(ts => ts.selected).length)

    const countSelectedTickets = computed(() =>
        allTicketsets.value.reduce((acc, ts) => acc + (ts.selected ? (ts.count ?? 0) : 0), 0)
    )

    function selectAll() {
        for (const ts of allTicketsets.value) ts.selected = selectAllActive.value
    }

    function done() {
        const ids = allTicketsets.value.filter(ts => ts.selected).map(ts => String(ts.id))
        events.setActiveTicketsetIds(ids)
        initSound()
        void router.push({ name: 'scanner' })
    }
</script>
